import BaseController from "confinus_ui/base_controller";
import { removeHashesFromQueryString } from "lib/util/add_parameter_to_url";
import { serialize } from "lib/util/serialize";

export default class SidebarFiltersController extends BaseController {
  public static targets = ["form"];

  declare private readonly formTarget: HTMLFormElement;

  // Override reseting other parameters on form submit via GET method - build request url explicitly
  public submit(e: Event) {
    e.preventDefault();

    const serializedForm = serialize(this.formTarget);

    // reset query string parameters
    const queryString = removeHashesFromQueryString(
      window.location.search,
      "ft",
      "utf8",
    );

    window.location.search = queryString + "&" + serializedForm;
  }
}
